import { getStore } from '@tmapy/redux';
export const getCurrentLocale = () => getStore().getState().intl.currentLocale;
//# sourceMappingURL=getCurrentLocale.js.map